import { render, staticRenderFns } from "./features.vue?vue&type=template&id=27fc44e7&"
import script from "./features.vue?vue&type=script&lang=js&"
export * from "./features.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27fc44e7')) {
      api.createRecord('27fc44e7', component.options)
    } else {
      api.reload('27fc44e7', component.options)
    }
    module.hot.accept("./features.vue?vue&type=template&id=27fc44e7&", function () {
      api.rerender('27fc44e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/pages/features.vue"
export default component.exports